import { CoreRootStore as DefaultCoreRootStore } from '@platform/front-core';

export class CoreRootStore extends DefaultCoreRootStore {
    getCurrentYear(): Promise<number> {
        return Promise.resolve(new Date().getFullYear());
    }
}
